import type { PropsWithChildren, ReactNode } from 'react'
import { clsx } from 'clsx'

import Icon, { type IconTypes } from '@components/utils/Icon'

export function GroupDetailsPanel({ children }: PropsWithChildren) {
  return (
    <dl className="tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:lg:grid-cols-3 tw:gap-x-8 tw:gap-y-4 tw:m-0">
      {children}
    </dl>
  )
}

type DetailRowProps = {
  icon: IconTypes
  label: string
  block?: boolean
  testId?: string
  children: ReactNode
}

export function DetailRow({ icon, label, block = false, testId, children }: DetailRowProps) {
  return (
    <div className="tw:flex tw:min-w-0 tw:flex-col tw:gap-2">
      <dt className="tw:inline-flex tw:items-end tw:gap-1.5 tw:text-gray-true-500 tw:font-bold tw:text-xs tw:uppercase tw:leading-[18px]">
        <Icon type={icon} width={20} height={20} />
        {label}
      </dt>
      <dd
        className={clsx(
          'tw:m-0 tw:text-sm tw:text-gray-900 tw:wrap-break-word',
          block ? 'tw:border-l-2 tw:border-gray-200 tw:pl-5' : 'tw:pl-[22px]'
        )}
        data-testid={testId}
      >
        {children}
      </dd>
    </div>
  )
}
